export default "__VITE_ASSET__CTvAKGlj__"